import { useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { CustomerDto } from '../dto/CustomerDto';
import { useTranslation } from 'react-i18next';

export function useCustomersCreateForm(): UseFormReturn<CustomerDto> {
  const { t } = useTranslation();

  return useForm({
    resolver: useMemo(
      () =>
        yupResolver(
          yup.object().shape({
            name: yup.string().label(t('Name')).required(),
            notes: yup.string().label(t('Notes')),
          }),
        ),
      [t],
    ),
  });
}
